export const getIsLoading = (state) => state.propertyAvailability?.isLoading;
export const getFilters = (state) => state.propertyAvailability.filters || {};

export const getRoomTypes = (state) => state.propertyAvailability.roomTypes;

export const getClassicRewardsFilter = (state) => state.propertyAvailability.filters?.classicRewards;
export const getDepositPayFilter = (state) => state.propertyAvailability.filters?.depositPay;
